// @ts-nocheck
/**
 * componentWalker.ts — WP-008 Semantic Validator
 *
 * Visits every component node in every layout of an element, recursing into
 * GroupComponent children. Depth is capped at 10 to mirror the structural
 * validator's guard and prevent stack overflow on adversarial documents.
 *
 * Pure TypeScript — no framework dependencies.
 */

import type { ComponentNode, ElementDefinition } from '../../types/canonical';

const MAX_DEPTH = 10;

/**
 * Calls `callback` for every component node in every layout of an element,
 * including group children recursively (depth-capped at 10).
 * Provides path and element context to the callback.
 */
export function walkComponents(
  element: ElementDefinition,
  elementIndex: number,
  callback: (component: ComponentNode, path: string, element: ElementDefinition) => void,
): void {
  for (let li = 0; li < element.layouts.length; li++) {
    const layout = element.layouts[li];
    const layoutPath = `elements[${elementIndex}].layouts[${li}].components`;
    walkComponentList(element, layout.components, layoutPath, callback, 0);
  }
}

// ── Private recursive walker ──────────────────────────────────────────────────

function walkComponentList(
  element: ElementDefinition,
  components: ComponentNode[],
  basePath: string,
  callback: (component: ComponentNode, path: string, element: ElementDefinition) => void,
  depth: number,
): void {
  if (depth >= MAX_DEPTH) {
    return;
  }
  for (let ci = 0; ci < components.length; ci++) {
    const component = components[ci];
    const componentPath = `${basePath}[${ci}]`;
    callback(component, componentPath, element);
    if (component.type === 'group') {
      walkComponentList(
        element,
        component.group.children,
        `${componentPath}.group.children`,
        callback,
        depth + 1,
      );
    }
  }
}
